import { Resource } from './../../global/domain/resource.model';
export class Cargo extends Resource {
  id: number;
  descricao: string;
  salario?: number;
}
